export const THEMES = [
    { id: 'midnight', scheme: 'dark', unlock: { type: 'default' } },
    { id: 'paper', scheme: 'light', unlock: { type: 'default' } },
    { id: 'ocean', scheme: 'dark', unlock: { type: 'level', value: 3 } },
    { id: 'forest', scheme: 'dark', unlock: { type: 'level', value: 5 } },
    { id: 'sand', scheme: 'light', unlock: { type: 'level', value: 8 } },
    { id: 'mono', scheme: 'dark', unlock: { type: 'level', value: 12 } },
    { id: 'sunset', scheme: 'dark', unlock: { type: 'achievement', code: 'wpm_50' } },
    { id: 'neon', scheme: 'dark', unlock: { type: 'achievement', code: 'streak_7' } },
    { id: 'sakura', scheme: 'light', unlock: { type: 'achievement', code: 'accuracy_99' } },
];
export function findTheme(id) {
    return THEMES.find((theme) => theme.id === id);
}
export function isThemeUnlocked(theme, level, achievementCodes) {
    switch (theme.unlock.type) {
        case 'default':
            return true;
        case 'level':
            return level >= theme.unlock.value;
        case 'achievement':
            return achievementCodes.has(theme.unlock.code);
    }
}
//# sourceMappingURL=themes.js.map